import Share from './index';
import { queryArticleThumbupsInfoInThird } from '../../js/api';
export default class ShareThird extends Share {
  constructor(el, name, data = {}) {
    super(el, name, (data = {}));
  }
  render() {
    const { isThumbUp, upsCount = 0 } = window.store;
    console.log('share render');
    queryArticleThumbupsInfoInThird()
      .then((response) => {
        const [upsCount, isThumbUp] = response;
        //避免接口报错时，用户点赞数据被兼容数据0覆盖
        window.store.upsCount < upsCount &&
          window.store.set('upsCount', upsCount);
        //更新store的数据，为之后点赞逻辑存储数据
        !window.store.isThumbUp && window.store.set('isThumbUp', isThumbUp);
        this.renderEl(window.store);
      })
      .catch((err) => {
        console.log(err);
        return 0;
      });
    this.renderEl({ isThumbUp, upsCount });
  }
}
